export default{
    faqs(state){
        return state.faqs;
    }
}